import { Alert, Anchor, Card, Container, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useOrgProject } from '@/context/OrgProjectContext/useOrgProject.ts';
import { useProjectHumanDecisions } from '@/hooks/api/runs/useHumanDecisions.ts';

const HumanDecisionsInbox = () => {
  const { projectId } = useOrgProject();
  const { data: decisions = [], isLoading, error } = useProjectHumanDecisions(projectId);

  return (
    <Container size="md" py="xl">
      <Stack>
        <Title order={2}>Human decisions</Title>
        <Text c="dimmed">Open, authorized review requests in this project.</Text>
        {error && <Alert color="red">Unable to load human decisions.</Alert>}
        {!isLoading && !error && !decisions.length && (
          <Alert color="gray">No pending human decisions.</Alert>
        )}
        {decisions.map((decision) => {
          const summary = decision.summary || 'A decision is required.';
          return (
            <Card key={decision.id} withBorder>
              <Stack gap="xs">
                <Text fw={600}>{summary}</Text>
                <Text size="sm">Status: {decision.status}</Text>
                <Anchor
                  component={Link}
                  to={`/automations/${decision.automation_id}/runs/${decision.run_id}?humanDecisionId=${decision.id}`}
                >
                  Open run and review
                </Anchor>
              </Stack>
            </Card>
          );
        })}
      </Stack>
    </Container>
  );
};

export default HumanDecisionsInbox;
